import React from 'react';
import { Shield, Phone, Envelope, WarningCircle } from '@phosphor-icons/react';

export default function SuspendedAccount() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Shield className="w-8 h-8 text-red-600" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Account Suspended
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Your account has been temporarily suspended
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <WarningCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Access Temporarily Restricted
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              Your account has been suspended by an administrator. Please contact support to resolve this issue.
            </p>

            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                <h4 className="text-sm font-medium text-blue-800 mb-2">What does this mean?</h4>
                <ul className="text-sm text-blue-700 space-y-1 text-left">
                  <li>• You cannot access your dashboard or account features</li>
                  <li>• All data remains secure and will be restored upon reactivation</li>
                  <li>• This is typically a temporary measure</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
                <h4 className="text-sm font-medium text-yellow-800 mb-2">Need help?</h4>
                <p className="text-sm text-yellow-700 mb-3">
                  Contact our support team for assistance with your account.
                </p>
                <div className="space-y-2">
                  <div className="flex items-center justify-center space-x-2 text-sm text-yellow-700">
                    <Phone className="w-4 h-4" />
                    <span>(555) 123-4567</span>
                  </div>
                  <div className="flex items-center justify-center space-x-2 text-sm text-yellow-700">
                    <Envelope className="w-4 h-4" />
                    <span>support@shift.healthcare</span>
                  </div>
                </div>
              </div>

              <div className="pt-4">
                <button
                  onClick={() => window.location.href = '/'}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
